<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="AlignCenter">
		<ul>
			<li>
				<p class="InstructionText">Search for students to email</p>
			</li>
			<li>
				<p class="InstructionText">Select students from 1st table</p>
			</li>
			<li>
				<p class="InstructionText">Fill in student emails in 2nd table</p>
			</li>
			<li>
				<p class="InstructionText">
					Press the email button and the students will receive a email with a QR code and link to register for the Digital ID app
				</p>
			</li>
		</ul>
	</div>
</div>

<!--Search Options-->
<div class="SearchOptionBorder TopMargin">
	<h4>Search Options:</h4>

	<div class="SearchOptionDiv">
		<label>School:</label>
		<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText"> </caass-schoolselector>

		<label>Grade Level:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGradeLevel"
			[(ngModel)]="SelectedGradeLevel"
			optionLabel="GradeLevelDesc"
			[filter]="true"
			filterBy="GradeLevelDesc"
			[showClear]="false"
			placeholder="Select a Grade Level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGradeLevel.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GradeLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevelItem.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Academy:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstAcademy"
			[(ngModel)]="SelectedAcademy"
			optionLabel="AcademyDesc"
			[filter]="true"
			filterBy="AcademyDesc"
			[showClear]="false"
			placeholder="Select an Academy"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedAcademy">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedAcademy.AcademyDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-AcademyItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ AcademyItem.AcademyDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Homeroom:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstHomeroom"
			[(ngModel)]="SelectedHomeroom"
			optionLabel="HomeRoom"
			[filter]="true"
			filterBy="HomeRoom"
			[showClear]="false"
			placeholder="Select a Homeroom"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedHomeroom">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedHomeroom.HomeRoom }}
					</div>
				</div>
			</ng-template>
			<ng-template let-HomeroomItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ HomeroomItem.HomeRoom }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Group:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="SelectedGroup"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupName"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGroup">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGroup.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOptionID" [(ngModel)]="ActiveOptionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActiveOption" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Already Printed:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="AlreadyPrintedID" [(ngModel)]="AlreadyPrintedID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAlreadyPrinted" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>
</div>

<!--Select Table-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab
			header="Add Students to List {{ SelectStudentsExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="SelectStudentsExpand"
		>
			<div>
				<caass-manual-student-table [loading]="loading" [lstPerson]="lstPerson" (AddToList)="onAddToList($event)"> </caass-manual-student-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--To Email Table-->
<div class="TopMarinExtra">
	<p-accordion>
		<p-accordionTab
			header="Students to Email {{ EmailStudentsExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="EmailStudentsExpand"
		>
			<div>
				<caass-manual-email-table
					[lstPerson]="lstToEmail"
					[Processing]="Processing"
					(SendEmail)="onSendEmail($event)"
					(RemovePerson)="onRemovePerson($event)"
					(RemoveAll)="onRemoveAll($event)"
				>
				</caass-manual-email-table>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>
